<template>
  <b-navbar toggleable="lg" type="dark" class="navbar-custom">
    <b-navbar-brand to="/"
      ><img src="/logo_psos_dark_bg.svg" class="logo" alt="Logo" />
      <sup class="version">alpha</sup></b-navbar-brand
    >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/submit">Submission</b-nav-item>
        <b-nav-item href="/docs/">Documentation</b-nav-item>
        <b-nav-item to="/about">About</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: "psos-navbar"
};
</script>
